__webpack_require__.p = "/bilingual_mapping_tool/";